import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import DynamicModalWithInput from "../../../components/DynamicModalWithInput/DynamicModalWithInput";

const LiVerticalTimeLine = ({ history, isLast, onClick, onDelete }) => {
  const [isActiveModalDelete, setIsActiveModalDelete] = React.useState(false);

  const handleDelete = (e) => {
    console.log(e);
    console.log(history);
    onDelete(history.id);
    setIsActiveModalDelete(false);
  };

  return (
    <React.Fragment>
      <DynamicModalWithInput
        isOpen={isActiveModalDelete}
        toggle={() => setIsActiveModalDelete(prev => !prev)}
        action={handleDelete}
        header={(history?.change_description || "No description")}
        what="delete"
        alertColor="danger"
        alertText="It is not possible to restore the offer history after deletion"
      />
      <LiStyled className="event-list">
        <div className="event-timeline-dot">
          <i className="bx bx-right-arrow-circle" />
        </div>
        <div className="media">
          <div className="media-body">
            <div>
              <h5>
                <span className="history-label"
                      onClick={() => onClick(history)}
                >
                  {(isLast && (!history?.change_description || history?.change_description === "No description"))
                    ? "Created offer"
                    : (history?.change_description || "No description")}
                </span>
                {onDelete && <small className="btn-history-delete" onClick={() => setIsActiveModalDelete(true)}>
                  {/*Delete*/}
                  <i className="bx bx-trash-alt" />
                </small>}
              </h5>
              <p className="text-muted">{`${history?.date_from} - ${history?.date_to}`}</p>
            </div>
          </div>
        </div>
      </LiStyled>
    </React.Fragment>
  );
};

const LiStyled = styled.li`
  h5 {

    span.history-label {
      transition: .1s;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
        color: #556ee6;
      }
    }

    small.btn-history-delete {
      transition: .1s;
      //color: #50a5f1 !important;
      color: #4084c1;
      cursor: pointer;
      margin-left: 10px;

      &:hover {
        color: #556ee6 !important;
      }
    }
  }
`;

LiVerticalTimeLine.propTypes = {
  history: PropTypes.any,
  isLast: PropTypes.bool,
  onClick: PropTypes.func,
  onDelete: PropTypes.func
};

export default LiVerticalTimeLine;
